import { render, staticRenderFns } from "./ProductsTableOrders.vue?vue&type=template&id=4a53428c&"
import script from "./ProductsTableOrders.vue?vue&type=script&lang=js&"
export * from "./ProductsTableOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports